import { useCallback, useState } from 'react';
import MedicalIndicationForm from './components/MedicalIndicationForm';
import SendIndicationPanel from './components/SendIndicationPanel';
import type { SaveIndicationResponse } from '../../services/MedicalIndicationController';
import './MedicalIndicationView.scss';

interface MedicalIndicationViewProps {
  embeddedPatientId?: number;
  embeddedProfessionalId?: number | null;
  onExitFlow?: () => void;
  onSwitchToStudyOrder?: () => void;
}

type ViewState =
  | { kind: 'form' }
  | { kind: 'saved'; result: SaveIndicationResponse };

export default function MedicalIndicationView({
  embeddedPatientId,
  embeddedProfessionalId,
  onExitFlow,
  onSwitchToStudyOrder,
}: MedicalIndicationViewProps) {
  const [viewState, setViewState] = useState<ViewState>({ kind: 'form' });

  const patientId = embeddedPatientId ?? 0;

  const handleSaved = useCallback((result: SaveIndicationResponse) => {
    setViewState({ kind: 'saved', result });
  }, []);

  const handleNewIndication = useCallback(() => {
    setViewState({ kind: 'form' });
  }, []);

  if (!patientId) return null;

  return (
    <div className="medical-indication-view">
      {viewState.kind === 'form' ? (
        <MedicalIndicationForm
          patientId={patientId}
          embeddedProfessionalId={embeddedProfessionalId}
          onSaved={handleSaved}
          onSwitchToStudyOrder={onSwitchToStudyOrder}
          onCancel={onExitFlow}
        />
      ) : (
        <SendIndicationPanel
          result={viewState.result}
          onNewIndication={handleNewIndication}
          onBack={onExitFlow}
        />
      )}
    </div>
  );
}
